<template lang="pug">
  div
    bjm(v-show="isBjm" :perfectData="perfectData" @showFree="isBjm = false")
    free(v-show="!isBjm" :perfectData="perfectData" @showBjm="isBjm = true")
</template>

<script>
import emitter from '../../../../ui/src/mixins/emitter.js'
const bjm = () => import('./bjm')
const free = () => import('./free')
export default {
  components: { bjm, free },
  props: {
    perfectData: {
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      isBjm: true
    }
  },
  mixins: [emitter],
  watch: {
    isBjm: {
      immediate: true,
      handler(v) {
        this.dispatch('cover', 'changetitle', v ? '加入班级' : '自由注册')
        this.dispatch(
          'cover',
          'changetip',
          v ? '' : '该方式注册未加入班级，无法收到教师布置的练习哦~'
        )
      }
    }
  }
}
</script>

<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/components/login/components/perfect/app.vue